import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class ContractCommodity extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    fetchResult(req) {
        return this.repo.getContractCommodity(req);
    }
}
export default ContractCommodity;
